'use client'
import cn from 'classnames'
import { FunctionComponent, useCallback, useRef, useState } from 'react'

import { useClickOutside } from '@/hooks/clickOutside'
import { Icon } from '@/icons'

import { NavigationLink } from '@/store/NavigationMenu/NavigationTypes'

import { NavigationDropdown } from '../NavigationDropdown'

import styles from './NavigationLinkWithSubMenu.module.scss'

type NavigationItemProps = {
  subMenu: NavigationLink[]
  className?: string
  title: string
  onOpenMenu?: () => void
  onHideMenu?: () => void
  onLinkClick?: () => void
  telegram: string
  whatsapp: string
  max: string
}
export const NavigationLinkWithSubMenu: FunctionComponent<
  NavigationItemProps
> = ({
  subMenu,
  title,
  className,
  onLinkClick,
  onOpenMenu,
  onHideMenu,
  telegram,
  whatsapp,
  max,
}) => {
  const [visibleSubMenu, setVisibleSubMenu] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const openSubMenu = useCallback(() => {
    setVisibleSubMenu(true)
    if (onOpenMenu != null) {
      onOpenMenu()
    }
  }, [onOpenMenu])

  const hideSubMenu = useCallback(() => {
    setVisibleSubMenu(false)
    if (onHideMenu != null) {
      onHideMenu()
    }
  }, [onHideMenu])

  const toggleSubMenu = useCallback(() => {
    if (visibleSubMenu) {
      hideSubMenu()
    } else {
      openSubMenu()
    }
  }, [hideSubMenu, openSubMenu, visibleSubMenu])

  const handleClickOutside = useCallback(
    (e: any) => {
      if (
        visibleSubMenu &&
        containerRef.current != null &&
        !containerRef.current.contains(e.target as Node)
      ) {
        hideSubMenu()
      }
    },
    [hideSubMenu, visibleSubMenu]
  )

  useClickOutside(handleClickOutside)

  return (
    <div className={cn(styles.container)} ref={containerRef}>
      <button
        onClick={toggleSubMenu}
        className={cn(className, styles.link, {
          [styles.isOpen]: visibleSubMenu,
        })}
      >
        <span className={styles.title}>{title}</span>
        <Icon
          name="chevron"
          className={cn(styles.iconChevron, {
            [styles.isOpen]: visibleSubMenu,
          })}
        />
      </button>
      <NavigationDropdown
        isVisible={visibleSubMenu}
        title={title}
        onHide={hideSubMenu}
        menuList={subMenu}
        onLinkClick={onLinkClick}
        telegram={telegram}
        whatsapp={whatsapp}
        max={max}
      />
    </div>
  )
}
